import { useId } from "react";
import { Checkbox, Link } from "@mui/material";
import { useTranslations } from "use-intl";

interface Props {
  termsAndConditions: boolean;
  onTermsChange: (checked: boolean) => void;
  onMoreDetails: () => void;
}

const Summary = ({
  termsAndConditions,
  onTermsChange,
  onMoreDetails,
}: Props) => {
  const t = useTranslations();
  const checkboxId = useId();

  return (
    <>
      <div className="section-title mt-4">{t("summary")}</div>

      <div className="section-card mt-2 flex gap-2 text-sm">
        <div className="shrink-0">
          <Checkbox
            id={checkboxId}
            checked={termsAndConditions}
            onChange={(e, checked) => {
              onTermsChange(checked);
            }}
            sx={{ p: 0 }}
          />
        </div>

        <div className="flex flex-col gap-1 pt-1">
          <label
            className="text-sm font-semibold text-text-primary"
            htmlFor={checkboxId}
          >
            {t("flights.acceptGeneralTerms")}
          </label>
          <div className="text-sm text-text-tertiary">
            {t("flights.acceptGeneralTermsWarning")}
          </div>
          <Link onClick={() => onMoreDetails()} sx={{ fontSize: "14px" }}>
            {t("moreDetails")}
          </Link>
        </div>
      </div>
    </>
  );
};

export default Summary;
